<template>
<div>
  <el-form ref="form" :model="form" >
    <!-- 日期选择 -->
    <el-form-item :label="$t('lang.SelectAll')">
      <el-col :span="8">
        <el-date-picker type="date" placeholder="选择日期"  v-model="form.startTime" style="width: 100%;"></el-date-picker>
      </el-col>
      <el-col class="line" :span="1">-</el-col>
      <el-col :span="8">
        <el-date-picker type="date" placeholder="选择日期"  v-model="form.endTime" style="width: 100%;"></el-date-picker>
      </el-col>
    </el-form-item>
    <!-- 替换类型选择 -->
    <el-form-item :label="$t('lang.replaceType')">
      <el-col :span="17">
        <el-select
         class="typeSelect"
          v-model="form.replaceType"
          :placeholder="$t('lang.select')">
            <el-option
              v-for="(item, index) in replaceTypeList"
              :key="index"
              :label="$t(`lang.${item.label}`)"
              :value="item.value"
            >
            </el-option>
        </el-select>
      </el-col>
    </el-form-item>
    <!-- 选择查找的文件 -->
    <el-form-item :label="$t('lang.find')">
      <el-col :span="17">
        <public-file-search :renderNode="renderNode" @mediaInput='mediaInput(1,$event)' @getSearchData='getMediaData(1,$event)' v-if="!form.replaceType"></public-file-search>
        <live-source-search v-else @selectSource='selectSource(1,$event)' @sourceInput='sourceInput(1,$event)'></live-source-search>
        <!-- <el-input  v-model="form.fileName"></el-input> -->
      </el-col>
    </el-form-item>
    <!-- 选择替换的文件 -->
    <el-form-item :label="$t('lang.replace')">
      <el-col :span="17">
        <public-file-search :renderNode="renderNode"  @mediaInput='mediaInput(0,$event)' @getSearchData='getMediaData(0,$event)' v-if="!form.replaceType"></public-file-search>
        <live-source-search v-else @selectSource='selectSource(0,$event)' @sourceInput='sourceInput(0,$event)'></live-source-search>
      </el-col>
    </el-form-item>
    <!-- 查找按钮 -->
    <el-form-item class="button">
      <el-button size="small" type="primary" @click="findEvent"  :loading='findLoading'  class="FindButton">{{$t('lang.FindOccurrences')}}</el-button>
    </el-form-item>
  </el-form>
  <!-- 查找的内容列表 -->
  <div class="searchList">
    <div class="seachHead">
      <!-- 全选按钮 -->
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" :disabled="!fileList.length">{{$t('lang.SelectAll')}}</el-checkbox>
      <span>{{$t('lang.SearchResults')}}</span>
      <el-tooltip placement="right-start" >
        <div slot="content">
          {{$t('lang.OnlyScheduledEvents')}}
        </div>
          <i class="iconfont icon-help"></i>
      </el-tooltip>
    </div>
    <div v-if="!fileList.length" class="noResults">{{$t('lang.NoResults')}}</div>
     <el-checkbox-group v-else v-model="checkedFile"  fill='#33AB4F' @change="handleCheckedChange" text-color='#33AB4F'>
      <el-checkbox v-for="item in fileList" :label="item.id" :key="item.id" @click="Checkbox">
        <el-tooltip class="item" effect="dark" :content="item.startTime+' - '+item.endTime +' '+ item.segmentType" placement="top-start">
          <span @click.prevent="everyCheckbox(item)">{{item.startTime+' - '+item.endTime}} {{item.segmentType}}</span>
        </el-tooltip>
      </el-checkbox>
    </el-checkbox-group>

  </div>
  <div class="footer" v-if="fileList.length">
     <el-button size="small"  @click="replaceEvent"  :loading='replaceLoading' class="ReplaceButton">{{$t('lang.ReplaceSelected')}}</el-button>
  </div>
</div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import Bus from '@/assets/js/vueBus.js'
import PublicFileSearch from './PublicFileSearch.vue'
import toTips from '@/assets/js/toTipsObj'
import LiveSourceSearch from './liveSourceSearch.vue'
export default {
  data () {
    return {
      // 表单内容
      form: {
        startTime: Outil.getWeek()[0],
        endTime: Outil.getWeek()[6],
        fileName: '',
        replaceType: 0
      },
      // 刷新树形文件夹
      renderNode: 0,
      checkedFile: [], // 选中的event id集合
      // 设置 indeterminate 状态，只负责样式控制
      isIndeterminate: true,
      // 是否全选
      checkAll: false,
      // 要替换的文件信息
      replaceMessage: {},
      fileList: [], // 搜索结果的event列表
      timeArr: [], // 选中文件的持续时间
      // 查找的文件信息
      fileData: {},
      findLoading: false,
      replaceLoading: false,
      // 选择类型列表
      replaceTypeList: [{
        label: 'Media',
        value: 0
      }, {
        label: 'LiveSource',
        value: 1
      }]
    }
  },
  components: {
    PublicFileSearch,
    LiveSourceSearch
  },
  created () {

  },
  methods: {
    // source选择
    selectSource (type, data) {
      if (data.type == 'RTP') {
        data = { ...data, sourceId: data.mainPeerId }
      } else {
        data = { ...data, sourceId: data.peerId }
      }
      if (type) {
        this.fileData = data
      } else {
        this.replaceMessage = data
      }
    },
    // 获取media信息
    getMediaData (type, data) {
      if (type) {
        this.fileData = data
      } else {
        this.replaceMessage = data
      }
    },
    // media输入
    mediaInput (type, data) {
      if (type) {
        if (!data) {
          this.fileData = {}
        }
      } else {
        if (!data) {
          this.replaceMessage = {}
        }
      }
    },
    // source输入
    sourceInput (type, data) {
      if (type) {
        if (!data) {
          this.fileData = {}
        }
      } else {
        if (!data) {
          this.replaceMessage = {}
        }
      }
    },
    // 查找结果
    findEvent (val) {
      if (this.fileData.sourceId) {
        const params = {
          startTime: this.form.startTime.getTime(),
          endTime: this.form.endTime.getTime() + 24 * 60 * 60 * 1000,
          sourceId: this.fileData.sourceId,
          programId: this.$BehaviorSyns.getProgramId()
        }
        if (val) {
          this.findLoading = true
        }
        this.axios.post(Outil.getUrl('/searchAndReplace/searchEvent'), params)
          .then((res) => {
            this.findLoading = false
            if (res.status == 200) {
              if (res.data.errorCode == '0x0') {
                this.fileList = this.dealTime(res.data.result)
                this.checkedFile = []
              } else {
                const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
                this.$message.info(errorInfo)
              }
            }
          }).catch(() => {})
      } else {
        this.$message(this.$t('lang.searchFile'))
      }
    },
    // 处理时间
    dealTime (val) {
      const newFileList = val.map(item => {
        return { ...item, startTime: Outil.TransitionCurrentTime1(new Date(item.startTime)), endTime: Outil.TransitionCurrentTime1(new Date(item.endTime)), durationTime: Math.floor((item.endTime - item.startTime) / 1000), hours: new Date(item.endTime).getHours(), nowDate: Outil.TransitionCurrentTime1(new Date(item.endTime - 24 * 60 * 60 * 1000)) }
      })

      return newFileList
    },
    // 全选按钮切换
    handleCheckAllChange (val) {
      const checkedFile = this.fileList.map(v => { return v.id })
      const timeArr = []
      this.checkedFile = val ? checkedFile : []
      this.checkedFile.forEach(v => {
        this.fileList.forEach(item => {
          if (item.id == v) {
            timeArr.push(item.durationTime)
          } else {

          }
        })
      })
      this.timeArr = timeArr
      this.isIndeterminate = false
    },
    // 单选按钮切换
    handleCheckedChange (value) {
      const timeArr = []
      this.checkedFile.forEach(v => {
        this.fileList.forEach(item => {
          if (item.id == v) {
            timeArr.push(item.durationTime)
          } else {

          }
        })
      })
      this.timeArr = timeArr
      // 全部选择让全选选中
      const checkedCount = value.length
      this.checkAll = checkedCount === this.fileList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.fileList.length
    },
    // 点击搜索结果跳转到对应事件
    everyCheckbox (item) {
      Bus.$emit('clickSearchResult', item)
    },
    Checkbox (val) {
    },
    // 替换事件
    replaceData () {
      const params = {
        oldSourceId: this.fileData.sourceId,
        sourceId: this.replaceMessage.sourceId,
        programId: this.$BehaviorSyns.getProgramId(),
        eventIds: this.checkedFile,
        modeType: Outil.getProgramReceiver('modeType'),
        replaceType: this.form.replaceType
      }
      this.replaceLoading = true
      this.axios.post(Outil.getUrl('/searchAndReplace/replaceEvent'), params)
        .then((res) => {
          if (res.status == 200) {
            this.replaceLoading = false
            if (res.data.errorCode == '0x0') {
              Bus.$emit('updateEventList')
              this.$message.success('Success')
              this.findEvent(false)
              this.checkedFile = []
              this.checkAll = false
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch(() => {})
    },
    // 替换事件
    replaceEvent () {
      if (this.fileData.sourceId && this.replaceMessage.sourceId && this.checkedFile.length > 0) {
        if (!this.form.replaceType) {
          if (this.fileData.videoTimes == this.replaceMessage.videoTimes) {
            this.replaceData()
          } else {
            this.$message(this.$t('lang.sameDuration'))
          }
        } else {
          this.replaceData()
        }
      } else {
        this.$message(this.$t('lang.selectReplace'))
      }
    }
  }
}
</script>

<style lang='less' scoped>
  ::v-deep.el-form{
     padding-top: 24px;
    .el-form-item{
      margin: 0;
      .el-form-item__label{
        width: 28%;
        text-align: left;
        color: #DBDBDB;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .el-form-item__content{
      .typeSelect{
        width: 100%;
        .el-input{
          .el-input__inner{
            background: #252525;
            color: #fff;
          }
          // .el-input__suffix{
          //   .el-icon-arrow-up::before{
          //     content: "\E605"
          //   }
          // }
        }
      }
        .el-input__inner{
            height: 32px;
            border: 1px solid #444
        }
        .el-input--prefix{
          .el-input__inner{
          padding-right: 10px ;
          height: 32px;
          border: 1px solid #444
          }
        }
        .PublicFileSelect{
          .el-select{
            width: 100%;
            .el-input__inner{
            border: 1px solid #444;
            background-color: #252525;
            }
          }

        }
      }
    }
    .el-form-item:nth-child(4){
         text-align: right;
         .FindButton{
           width: 150px;
         }
    }
    .button{
      text-align: right;
    }
   }
   .searchList{
     margin-top: 24px;
     .seachHead{
       display: flex;
       border-bottom: 1px solid #555555;
       ::v-deep.el-checkbox{
         .el-checkbox__label{
            // font-size: 14px !important;
         }
         .el-checkbox__input.is-checked{
            .el-checkbox__inner{
              background: #0c6 !important;
            }
            .el-checkbox__inner::after{
              border-color: #333333 !important;
            }
        }
        .el-checkbox__input.is-indeterminate{
            .el-checkbox__inner{
              background: none;
              border-color: #fff !important
            }
            .el-checkbox__inner::before{
               background: none;
            }
        }
       }
       span{
          font-weight: 400;
          font-size: 12px;
          line-height: 24px;
          padding-left: 24px;
       }
       i{
         padding-left: 8px;
         color: #999999;
       }
     }
     .noResults{
       padding-top: 24px;
       color: #666666;
     }
     ::v-deep.el-checkbox-group{
        height: 200px;
        border-bottom: 1px solid #555555;
        overflow-y: auto;
       .el-checkbox{
         text-align: left;
         margin-bottom:0;
        //  .el-checkbox__input{
        //        height: 32px
        //  }
         .el-checkbox__label{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          vertical-align: middle;
          max-width: 96%;
         }
       }
       .el-checkbox.is-checked{
        background-color: rgba(57, 170, 80, 0.25) !important;
       }
       .el-checkbox__input.is-checked{
         .el-checkbox__inner{
           background: #0c6 !important;
         }
        .el-checkbox__inner::after{
           border-color: #333333 !important;
         }
       }
     }
   }
   .footer{
     margin-top: 20px;
     text-align: right;
     .ReplaceButton{
       background-color: #E56464;
;
     }
   }
</style>
